module.exports = __webpack_public_path__ + "img/sc.5a8c79c0.svg";